import { InputArea, Modal } from '@bitcine/cinesend-theme/dist'
import useStore from '../../../hooks/use_store'
import { useQueryClient } from '@tanstack/react-query'

const ResolveIssueModal = ({ issue, onClose, queryKey }) => {
  const { deleteModel } = useStore()
  const queryClient = useQueryClient()
  const { uuid, description, deleted_at } = issue

  const resolveIssue = () => {
    deleteModel.mutate(
      {
        endpoint: `issues`,
        id: uuid,
        confirmMessage: `Are you sure you want to resolve this issue?`,
      },
      {
        onSuccess: (res) => queryClient.invalidateQueries([queryKey]),
        onError: (err) => console.log(err),
        onSettled: () => onClose(),
      }
    )
  }

  return (
    <Modal
      header={`Resolve Issue`}
      onClose={() => onClose()}
      confirmButton={
        deleted_at
          ? null
          : {
              text: `Resolve`,
              onClick: () => resolveIssue(),
            }
      }
    >
      <div className='min-w-96'>
        <InputArea value={description} resize={true} disabled={true}></InputArea>
      </div>
    </Modal>
  )
}

export default ResolveIssueModal
